var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFallbackSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#BDC3C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 40C32.7 40 29.875 38.825 27.525 36.475C25.175 34.125 24 31.3 24 28C24 24.7 25.175 21.875 27.525 19.525C29.875 17.175 32.7 16 36 16C39.3 16 42.125 17.175 44.475 19.525C46.825 21.875 48 24.7 48 28C48 31.3 46.825 34.125 44.475 36.475C42.125 38.825 39.3 40 36 40ZM18 64C16.35 64 14.938 63.413 13.764 62.239C12.588 61.063 12 59.65 12 58V55.6C12 53.9 12.438 52.337 13.314 50.911C14.188 49.487 15.35 48.4 16.8 47.65C19.9 46.1 23.05 44.937 26.25 44.161C29.45 43.387 32.7 43 36 43C39.3 43 42.55 43.387 45.75 44.161C48.95 44.937 52.1 46.1 55.2 47.65C56.65 48.4 57.812 49.487 58.686 50.911C59.562 52.337 60 53.9 60 55.6V58C60 59.65 59.413 61.063 58.239 62.239C57.063 63.413 55.65 64 54 64H18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFallbackSquare);
export default __webpack_public_path__ + "static/media/user-fallback-square.42c4e704c9491f2f5bcc3e9501f95c8a.svg";
export { ForwardRef as ReactComponent };